import styles from './EventTitleField.module.css';

interface EventTitleFieldProps {
  value: string;
  onChange: (title: string) => void;
  /** Empty when Save was pressed. See `missing`. */
  gap?: boolean;
  placeholder?: string;
}

/**
 * The Chat Day's name, and the biggest thing on the form.
 *
 * It leads the column with no eyebrow over it. What names the *kind* is the
 * placeholder, which is already this field's label and leaves the moment it is
 * answered; a heading above it would be two titles, one of them uneditable and
 * neither saying anything the other did not.
 */
export function EventTitleField({
  value,
  onChange,
  gap = false,
  placeholder = 'Add title',
}: EventTitleFieldProps) {
  return (
    <div className={styles.row}>
      <div className={gap ? styles.fieldGap : styles.field}>
        <input
          className={styles.input}
          value={value}
          placeholder={placeholder}
          autoFocus
          aria-label="Title"
          // Colour is not the only thing saying this is unanswered: a red
          // underline is invisible to a screen reader, and this form deliberately
          // has no prose in the footer carrying the same fact.
          aria-invalid={gap || undefined}
          data-gap={gap || undefined}
          onChange={(event) => onChange(event.target.value)}
        />
      </div>
    </div>
  );
}
